<div class="need-help">
    <div class="need-help__menu-panel">
        <h3 class="need-help__title">{{ 'menu.modals.needHelp.title' | translate }}</h3>
        <div class="need-help__menu">
            @for (button of currentConfig === 'd-carbonize' ? helpButtons : helpButtons_client; track button) {
                <button
                    type="button"
                    class="help-entry"
                    [class.is-active]="button.section === currentSection"
                    [attr.aria-pressed]="button.section === currentSection"
                    [disabled]="button.disabled"
                    (click)="showSection(button.section)">
                    <span class="help-entry__head">
                        <span class="help-entry__icon material-symbols-outlined icon-lg" aria-hidden="true">{{
                            button.icon
                        }}</span>
                        <span class="help-entry__title">{{ button.titleKey | translate }}</span>
                    </span>
                    <span class="help-entry__description">{{ button.descriptionKey | translate }}</span>
                </button>
            }
        </div>
    </div>
    <div class="need-help__content">
        @if (currentSection === 'userGuide') {
            <ng-container
                *ngTemplateOutlet="
                    download;
                    context: {
                        title: 'menu.modals.needHelp.userGuide.content.title',
                        label: 'menu.modals.needHelp.userGuide.content.download',
                        href: 'assets/data/userGuides/userGuide_' + local + '.pdf',
                        fallback: 'assets/data/userGuides/userGuide_en.pdf',
                    }
                " />
        }
        @if (currentSection === 'faq') {
            <div class="need-help__section">
                <app-faq></app-faq>
            </div>
        }
        @if (currentSection === 'contactBanker') {
            <div class="need-help__section">
                <img
                    src="assets/images/logo/logo-h.webp"
                    [alt]="'Logo ' + configService.config.client.name"
                    class="need-help__logo" />
                <ng-container *ngTemplateOutlet="contactForm; context: { $implicit: undefined }" />
            </div>
        }
        @if (currentSection === 'contactDCarbonize') {
            <div class="need-help__section">
                <img
                    src="assets/images/logo/logo-provider.webp"
                    alt="Logo D-Carbonize"
                    class="need-help__logo"
                    [class.need-help__logo--partner]="partnership"
                    [class.need-help__logo--provider]="!partnership" />
                <ng-container *ngTemplateOutlet="contactForm; context: { $implicit: 'dcarbonize' }" />
            </div>
        }
        @if (currentSection === 'methode') {
            <ng-container
                *ngTemplateOutlet="
                    download;
                    context: {
                        title: 'menu.modals.needHelp.methode.title',
                        label: 'menu.modals.needHelp.methode.download',
                        href: 'assets/data/methodology/methodology_' + local + '.pdf',
                        fallback: 'assets/data/methodology/methodology_en.pdf',
                    }
                " />
        }
    </div>
</div>

<!-- A document to download: the illustration, then its title and the download button. -->
<ng-template #download let-title="title" let-label="label" let-href="href" let-fallback="fallback">
    <div class="guide">
        <div class="guide__illustration">
            <span class="guide__badge">{{ 'common.title' | translate }}</span>
        </div>
        <div class="guide__footer">
            <span class="guide__title">{{ title | translate }}</span>
            <p-button icon="ms ms-download" [label]="label | translate" (onClick)="downloadFile(href, fallback)" />
        </div>
    </div>
</ng-template>

<!-- The e-mail form, sent to the client's contact or to D-Carbonize (`to`). -->
<ng-template #contactForm let-to>
    <form class="form-grid" [formGroup]="form" (ngSubmit)="sendEmail(to)">
        <div class="form-field">
            <label for="subject" class="form-field__label form-field__label--required">{{
                'menu.modals.needHelp.contact.subject' | translate
            }}</label>
            <input pInputText type="text" id="subject" formControlName="subject" />
            @if (form.controls['subject'].invalid && form.controls['subject'].touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
        <div class="form-field">
            <label for="description" class="form-field__label form-field__label--required">{{
                'menu.modals.needHelp.contact.content' | translate
            }}</label>
            <textarea pTextarea id="description" formControlName="description" rows="8"></textarea>
            @if (form.controls['description'].invalid && form.controls['description'].touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
        <div class="form-actions">
            <p-button type="submit" [label]="'menu.modals.needHelp.contact.send' | translate" />
        </div>
    </form>
</ng-template>
